import gql from "graphql-tag";

export const APPLY_FOA_FOR_FLIGHTS = gql`
    mutation applyFoaForFlights($flightFilter: FilterInput, $foaFilter: FilterInput) {
        flightAndObjectActionService_apply(flightFilter: $flightFilter, foaFilter: $foaFilter)
    }
`;

export const LOAD_REGISTRATIONS_PARAMETER = gql`
    query loadRegistrationsParameter($params: FindByFilterParamsInput) {
        parameterService_findByFilter(params: $params) {
            results { id name value }
        }
    }
`;

export const SAVE_REGISTRATIONS_PARAMETER = gql`
    mutation saveRegistrationsParameter($params: SaveParams_LongInput) { 
        parameterService_save(params: $params) { id name value }
    }
`;

export const GET_FOA_IDS_FOR_FLIGHT = gql`
    query getFoaIdsForFlight($id: Long) {
        flightAndObjectActionService_flightAndObjectActionIds(id: $id)
    }
`;